export default function InfoIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "width" | "height" | "fill" | "className"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
    >
      <path
        d="M8.00004 14.6666C4.31804 14.6666 1.33337 11.682 1.33337 7.99998C1.33337 4.31798 4.31804 1.33331 8.00004 1.33331C11.682 1.33331 14.6667 4.31798 14.6667 7.99998C14.6667 11.682 11.682 14.6666 8.00004 14.6666ZM8.00004 13.3333C9.41453 13.3333 10.7711 12.7714 11.7713 11.7712C12.7715 10.771 13.3334 9.41447 13.3334 7.99998C13.3334 6.58549 12.7715 5.22894 11.7713 4.22874C10.7711 3.22855 9.41453 2.66665 8.00004 2.66665C6.58555 2.66665 5.229 3.22855 4.2288 4.22874C3.22861 5.22894 2.66671 6.58549 2.66671 7.99998C2.66671 9.41447 3.22861 10.771 4.2288 11.7712C5.229 12.7714 6.58555 13.3333 8.00004 13.3333ZM7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331Z"
        fill={props.fill || "#E6483D"}
      />
    </svg>
  );
}
